//= ========================================================================
import React from 'react';
import {
  add_contact_name_str,
  addPathToList,
  bank,
  branch_name,
  configure_settings_manually,
  getSubCategoryId,
  recipient_id,
  recipient_information,
  recipient_name,
  save_to_contacts,
  search_bank,
  search_branch,
  select_recipient,
} from '../../../utils/DictionaryManagementUtils';
import BreakLine from '../General/BreakLine';
import ManualRecipientConfigurations from './ManualRecipientConfigurations';
import ManualRecipientSwitcher from './ManualRecipientSwitcher';
import { LocStr } from '../../../utils/Utils';
import FullPagePanel from '../General/FullPagePanel';

const DefaultPanelManuelRecipient = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
  manualName,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];
  const { recipient } = service;
  const manual_recipient = recipient.manual_recipients[manualName];
  const editTextList = [
    'recipient_id', 'recipient_name', 'bank', 'branch_name', 'manual_name', 'next', 'search_bank', 'search_branch',
    'enter_details', 'recipient_information', 'add_contact_name_str']
    .filter((textElement) => {
      if (textElement === recipient_id) {
        return manual_recipient.manual_fields_list.recipient_id;
      }
      if (textElement === add_contact_name_str) {
        return manual_recipient.save_to_list && manual_recipient.add_contact_name;
      }
      if (textElement === recipient_information) {
        return manual_recipient.enable_recipient_validation;
      }
      if (textElement === search_branch) {
        return manual_recipient.manual_fields_list.branch_name && manual_recipient.search_from_list_branch_name;
      }
      if (textElement === search_bank) {
        return manual_recipient.manual_fields_list.bank && manual_recipient.search_from_list_bank;
      }
      if (textElement === recipient_name) {
        return manual_recipient.manual_fields_list[textElement];
      }
      if (textElement === recipient_name) {
        return manual_recipient.manual_fields_list[textElement];
      }
      if (textElement === recipient_id) {
        return manual_recipient.manual_fields_list[textElement];
      }
      if (textElement === bank) {
        return manual_recipient.manual_fields_list[textElement];
      }
      if (textElement === branch_name) {
        return manual_recipient.manual_fields_list[textElement];
      }
      return true;
    });
  const saveToContacts = manual_recipient.save_to_list ? ['save_to_contacts'] : [];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={LocStr(select_recipient, language)}
      panelSubHeadline={LocStr(`Manual: ${manual_recipient.manual_name}`, language)}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/recipient/manual_recipients/${manualName}/`)
        .concat(addPathToList(saveToContacts, `configurations/services/${subCategoryId}/recipient/`))}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/recipient/manual_recipients/${manualName}/`)
        .concat(addPathToList(saveToContacts, `configurations/services/${subCategoryId}/recipient/`))}
      tooltipsTitles={service.screens_ordering}
      paragraph={configure_settings_manually}
      isHollow
      language={language}
    >
      <ManualRecipientSwitcher
        onConfigChanged={onConfigChanged}
        manualName={manualName}
        manualRecipients={recipient.manual_recipients[manualName]}
      />
      <BreakLine />
      <ManualRecipientConfigurations
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        subCategoryId={subCategoryId}
        manualName={manualName}
      />
    </FullPagePanel>
  );
};

export default DefaultPanelManuelRecipient;
